<div class="line-item">
  <div class="row">
    <div *ngFor="let lineItem of cartOrderReviewObj?.entries; let i = index" class="content">
      <div class="item-detail">
        <p class="sr-no">{{ i + 1 }}</p>
      </div>
      <div class="item-detail">
        <cx-media class="rfqSearchTumbnail" [container]="lineItem?.product?.images">
        </cx-media>
      </div>
      <div class="item-detail description">
        <div class="sub-content">
          <div>{{ "orderCheckOut.partModelNo" | cxTranslate }}</div>
          <strong>{{ lineItem?.product?.code }}</strong>
        </div>
        <div class="sub-content">
          <div>{{ "orderCheckOut.partDescription" | cxTranslate }}</div>
          <strong>{{ lineItem?.product?.name }}</strong>
        </div>
        <div class="sub-content">
          <div>{{ "orderCheckOut.comment" | cxTranslate }}</div>
          <strong>{{ lineItem?.comment }}</strong>
        </div>
      </div>
      <div class="item-detail quant">
        <span class="sub-quant">{{ lineItem?.quantity }} {{ "orderCheckOut.each" | cxTranslate }}</span>
      </div>
      <div class="item-detail" style="position:relative;">
        <div class="sub-content" class="base-price">
          <div class="d-flex">
            <span>{{ "orderCheckOut.yourPrice" | cxTranslate }}</span>
            <!-- <a
                 (click)="this.breakUp = !this.breakUp;"
                 class="cart-entry-text-bold breakup-link" #viewBreakupLink>
                View Breakup
                <i *ngIf="!breakUp" class="material-icons">keyboard_arrow_down</i>
                <i *ngIf="breakUp" class="material-icons">keyboard_arrow_right</i>
              </a> -->
            <div>
              <bh-tooltip message='{{ "savedCart.expressDeliveryTooltipTxt" | cxTranslate}}' title="" hide="false"
                invisible="false">
                <a *ngIf="lineItem.expressAdder && lineItem.expressAdder?.value > -1" class='material-icons'
                  (click)="showBreakUp(i)" class="cart-entry-text-bold breakup-link link-color-eda" #viewBreakupLink>
                  {{ "orderCheckOut.viewBreakup" | cxTranslate }}
                  <i *ngIf="!breakUp" class="material-icons">keyboard_arrow_down</i>
                  <i *ngIf="breakUp" class="material-icons">keyboard_arrow_right</i>
                </a>
              </bh-tooltip>
              <a *ngIf="!(lineItem.expressAdder && lineItem.expressAdder?.value > -1)" (click)="showBreakUp(i)"
                class="cart-entry-text-bold breakup-link link-color" #viewBreakupLink>
                {{ "orderCheckOut.viewBreakup" | cxTranslate }}
                <i *ngIf="!breakUp" class="material-icons">keyboard_arrow_down</i>
                <i *ngIf="breakUp" class="material-icons">keyboard_arrow_right</i>
              </a>
            </div>
            <div class="breakup-dropdown product-data-text" *ngIf="lineItem.showBreakup"
              (clickOutside)="closeMenu($event)" #breakupContent>
              <div class="row list-price-row m-0">
                <span class="price-menu-heading bold"> {{ "orderCheckOut.listPrice" | cxTranslate }}</span>
                <span class="price-menu-content bold">{{ lineItem.basePrice?.currencyIso }}
                  {{ lineItem.basePrice?.formattedValue }}</span>
              </div>
              <div class="mb-4" *ngIf="lineItem.discountDetails?.length > 0">
                <div class="row discounts" *ngFor="let discounts of lineItem.discountDetails">
                  <span class="price-menu-heading col-6 p-0"> {{ getDiscountName(discounts.code)}}</span>
                  <span class="price-menu-content col-2 p-0">{{ discounts.appliedValue }}%</span>
                  <span class="price-menu-content col-4 p-0 text-right">{{ discounts.currency }} -{{
                    discounts.formattedValue }}</span>
                </div>
              </div>
              <div class="row tdiscounts" *ngIf="lineItem.afterMarket && lineItem.afterMarket?.value > -1">
                <span class="price-menu-heading col-6 p-0">{{ "orderCheckOut.aftermarketFactor" | cxTranslate }}</span>
                <span class="price-menu-content col-2 p-0">{{ lineItem.afterMarketPremium }}%</span>
                <span class="price-menu-content col-4 p-0 text-right">{{ lineItem.afterMarket?.currencyIso }}
                  {{ lineItem.afterMarket?.formattedValue }}</span>
              </div>
              <div class="row tdiscounts" *ngIf="lineItem.expressAdder && lineItem.expressAdder?.value > -1">
                <span class="price-menu-heading col-6 p-0">{{ "orderCheckOut.expressDeliveryAdder" | cxTranslate
                  }}</span>
                <span class="price-menu-content col-2 p-0">{{lineItem.expressAdderPercent}}%</span>
                <span class="price-menu-content col-4 p-0 text-right">{{ lineItem.expressAdder?.currencyIso }}
                  {{ lineItem.expressAdder?.formattedValue }}</span>
              </div>
              <!--Tariff surcharge div start-->
              <div class="row tdiscounts" *ngIf="lineItem.tariffCharges && lineItem.tariffCharges?.value > -1">
                <span class="price-menu-heading col-6 p-0">{{ "orderCheckOut.tariffSurcharge" | cxTranslate }}</span>
                <span class="price-menu-content col-2 p-0">{{lineItem.tariffChargesPercent}}%</span>
                <span class="price-menu-content col-4 p-0 text-right">{{ lineItem.tariffCharges?.currencyIso }}
                  {{ lineItem.tariffCharges?.formattedValue }}</span>
              </div>
              <!--Tariff surcharge div end-->
              <div class="row total-discounts" *ngIf="lineItem.discountDetails?.length > 0">
                <span class="price-menu-heading bold">{{ "orderCheckOut.totalAdjustment" | cxTranslate }}</span>
                <span class="price-menu-content bold">{{ lineItem.basePrice?.currencyIso }} -
                  {{
                  (lineItem.basePrice.value - lineItem.netPrice.value)| currency:
                  lineItem.basePrice?.currencyIso:"symbol-narrow" }}
                </span>
              </div>
              <div class="row net-price">
                <span class="price-menu-heading bold">{{ "orderCheckOut.netPrice" | cxTranslate }}</span>
                <span class="price-menu-content bold">{{ lineItem.netPrice?.currencyIso }}
                  {{ lineItem.netPrice?.formattedValue }}</span>
              </div>
            </div>
          </div>


          <strong>
            {{ lineItem?.netPrice?.currencyIso }}
            {{ lineItem?.netPrice?.formattedValue }}</strong>
        </div>
        <div class="sub-content price">
          <div>{{ "orderCheckOut.extendedPrice" | cxTranslate }}</div>
          <strong>{{ lineItem?.netPrice?.currencyIso }}
            {{ lineItem?.totalPrice?.formattedValue }}</strong>
        </div>
      </div>
      <ng-container *ngFor="let plant of lineItem?.plantAvailableAt">
        <div class="item-detail" *ngIf='plant?.defaultPlant == true'>
          <div class="sub-content">
            <div>{{ "orderCheckOut.reqShipdate" | cxTranslate }}</div>
            <strong>{{
              lineItem?.customerRequestedDate | date: "d MMM, yyyy"
              }}</strong>
          </div>
          <div class="sub-content price">
            <div>{{ "orderCheckOut.availableAt" | cxTranslate }}</div>
            <strong>{{
              plant?.name
              }}</strong>
          </div>
          <div class="sub-content info">
            <div>{{ "orderCheckOut.availInfo" | cxTranslate }}</div>
            <!-- <strong *ngIf="!lineItem?.quoteCartEntryType"
            >{{ "orderCheckOut.earlyShipDate" | cxTranslate }}
            {{
              lineItem?.availabilityDetail[0]?.committedDate
                | date: "d MMM, yyyy"
            }}</strong> -->

            <strong *ngIf="!lineItem?.quoteCartEntryType">
              {{ "orderCheckOut.qty" | cxTranslate }} - {{
              lineItem?.availabilityDetail[0]?.committedQuantity | number: "1.0-0"
              }} {{ "orderCheckOut.available" | cxTranslate }}
            </strong>

          </div>
        </div>
      </ng-container>

    </div>
  </div>
</div>